import React from 'react';
import { NotFound } from '@/components/Message/NotFound';
import { twMerge } from 'tailwind-merge';

interface PdfPhotoListSectionProps {
  heading: React.ReactNode;
  children: React.ReactNode;
  containerClassName?: string;
  listClassName?: string;
  isNotFound?: boolean;
  notFoundText?: string;
  itemsPerRow?: number;
}

export const PdfPhotoListSection = ({
  heading,
  children,
  containerClassName,
  listClassName,
  isNotFound,
  notFoundText,
  itemsPerRow = 4,
}: PdfPhotoListSectionProps) => {
  // Group children into rows to prevent page breaks within a row
  const childrenArray = React.Children.toArray(children);
  const rows: React.ReactNode[][] = [];
  for (let i = 0; i < childrenArray.length; i += itemsPerRow) {
    rows.push(childrenArray.slice(i, i + itemsPerRow));
  }

  return (
    <div className={twMerge('', containerClassName)}>
      {heading}
      {isNotFound ? (
        <div
          className={twMerge(
            'grid grid-cols-1 bg-gray-50 py-5 rounded-md',
            listClassName
          )}
        >
          <NotFound
            text={notFoundText}
            containerClassName="gap-1"
            iconClassName="-mt-1.5 text-lg"
            textClassName="text-sm"
          />
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {rows.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={twMerge(
                'grid grid-cols-4 gap-6 break-inside-avoid',
                listClassName
              )}
            >
              {row}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
